export default __webpack_public_path__ + "static/media/pagination-prev-disabled.ccff30da.svg";